// import './spot.scss';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { ListGroup, Accordion, Card, Row, Col, Container, Button, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { withRouter, Link } from "react-router-dom";
import ApiV2 from "../apiV2"

const DEFAULT_COUNTRY_PHOTO = {
    'United States': "https://www.virginholidays.co.uk/.imaging/Desktop/dam/0120998e-08f2-4805-b171-c71993976108.jpg",
    Germany: "https://www.studying-in-germany.org/wp-content/uploads/2013/02/how-to-study-in-germany.jpg",
    France: "https://media.cntraveler.com/photos/5d8cf7d5db6acf000833e6cc/master/pass/Eiffel-Tower_GettyImages-1060266626.jpg",
    Spain: "https://cdn.insuremytrip.com/resources/29337/spain_travel_insurance_seville.jpg",
    Greece: "https://www.azamara.com/sites/default/files/heros/jr-1-aug-2020-paros-greece-1800x1000_0.jpg",
    Italy: "https://cdn.cnn.com/cnnnext/dam/assets/170606121206-italy---travel-destination---shutterstock-517522957.jpg",
    Japan: "https://specials-images.forbesimg.com/imageserve/1179891725/960x0.jpg",
    Austrialia: "https://www.dbaudio.com/fileadmin/_processed_/1/8/csm_sydneyopera-house-au-2009-01_12a3f1a265.jpg",
    England: "https://news.itu.int/wp-content/uploads/2018/07/london-min-e1530887248858.jpg",
    China: "https://www.snopes.com/tachyon/2018/07/great_wall_of_china.jpg",
    Korea: "https://www.theinvisibletourist.com/wp-content/uploads/2019/08/featured_114.jpg",
    Thailand: "https://media.nomadicmatt.com/2019/11reasonsthailand.jpg",
    Default: "https://img.traveltriangle.com/blog/wp-content/tr:w-700,h-400/uploads/2018/09/swiss-alps.jpg"
}

function Request(props) {
    const [collection, setCollection] = useState({});
    const [collectionOwner, setCollectionOwner] = useState({});

    useEffect(() => {
        const fetchCollectionData = async () => {
            try {
                const response = await ApiV2.getSharelist(props.request.sharelistId);
                setCollection(response.data.data);
            }
            catch (error) {
                props.notifyFailure("Unable to load collection requests");
                console.log("Unable to fetch collectionData. Error: ", JSON.stringify(error));
            }
        }
        fetchCollectionData();
    }
        , []
    );

    useEffect(() => {
        const fetchSharer = async () => {
        try {
            const response = await ApiV2.getUser(props.request.sharerId);
            setCollectionOwner(response);            
        } 
        catch (error) {
            props.notifyFailure("Unable to load collection requests");
            console.log("unable to fetch user. Error: ", JSON.stringify(error));
        }
    }
    fetchSharer();
    }
        , []
    );  


    return (
    <>
        <ListGroup.Item className="spot-item px-2 py-1">
        <Accordion>
            <Card className="spot-item">
                <Card.Header className="p-0">
                    <Container>
                        <Row>
                            <Col xs={3} className="p-0">
                                <Image id="spot-image" src={DEFAULT_COUNTRY_PHOTO.Japan}></Image>
                            </Col>
                            <Col xs={7}>
                                <Row>
                                    <Col xs={10}>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0" className="w-100">
                                            <Container className="px-2">
                                                <Row>
                                                    <small><b>{((collectionOwner.firstName)?.charAt(0))?.toUpperCase() + collectionOwner?.firstName?.slice(1)}</b></small>
                                                </Row>
                                                <Row>
                                                    <small>sent you:</small>
                                                </Row>
                                                <Row>
                                                    <small><b>"{collection?.name}"</b></small>
                                                </Row>
                                            </Container>
                                        </Accordion.Toggle>
                                    </Col>
                                    <Col className="p-0 d-flex align-items-center justify-content-center" xs={2}>
                                        <FontAwesomeIcon className="fa-lg blue" icon={faCheckCircle}
                                            onClick={() => props.handleResponse("true", collection.id)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="spot-option-col d-flex align-items-center" xs={2}>
                                <FontAwesomeIcon className="fa-lg blue" icon={faTimesCircle}
                                    onClick={() => props.handleResponse("false", collection.id)}
                                />  
                            </Col>
                        </Row>
                    </Container>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                    <Card.Body className="p-0">
                        <ListGroup>
                             
                            <ListGroup.Item className="py-1 px-2">
                            <Row>
                                <Col>
                                <small>
                                    <strong>Permissions: </strong>{props.request.permissions}
                                </small>
                                </Col>
                            </Row>
                            </ListGroup.Item>
                
                            <ListGroup.Item className="py-1 p-0">
                                <Row>
                                    <Col xs={10}>
                                        <small>
                                            <Row className="m-0 ml-2">
                                                <strong>Spots:  </strong>{4}
                                            </Row>
                                        </small>
                                    </Col>
                                </Row>
                                </ListGroup.Item>
                        </ListGroup>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    </ListGroup.Item>
    </>
    );
}

Request.propTypes = {
//   key: PropTypes.string.isRequired,
  request: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired,
  handleResponse: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default withRouter(Request);
